import { getSeverityClasses } from './severityStyles'

interface UrgencyBadgeProps {
  urgency: 'act_now' | 'watch' | 'monitor' | string
}

const URGENCY_META: Record<string, { label: string }> = {
  act_now: {
    label: '🔴 Act Now',
  },
  watch: {
    label: '🟡 Watch',
  },
  monitor: {
    label: '🟢 Monitor',
  },
}

export default function UrgencyBadge({ urgency }: UrgencyBadgeProps) {
  const normalized = (urgency || 'monitor').toLowerCase()
  const meta = URGENCY_META[normalized] ?? URGENCY_META.monitor
  const styles = getSeverityClasses(normalized)

  return (
    <span className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-semibold ${styles.border} ${styles.badge}`}>
      {meta.label}
    </span>
  )
}
